var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { rules } from './rule-config';
import FormModal from '@/common/components/Modal/FormModal.vue';
import FormInput from '@/common/components/Form/FormInput.vue';
import FormDatePicker from '@/common/components/Form/FormDatePicker.vue';
import FormRadio from '@/common/components/Form/FormRadio.vue';
import FormBoothCascader from '@/common/components/Form/FormBoothCascader.vue';
import { dateFns, deepCopy } from '@lhb/func';
import { getClueDetailInfo, putClueDetail, getClueStatusOptions } from '../../api';
import FormItemTip from '@/common/components/Form/FormItemTip.vue';
var EditClueModal = /** @class */ (function (_super) {
    __extends(EditClueModal, _super);
    function EditClueModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* props */
        /* data */
        _this.storeId = 0;
        _this.currentData = {};
        _this.showDialog = false;
        _this.title = '编辑活动';
        _this.loading = false;
        _this.firstLoading = true;
        _this.today = new Date(dateFns.changeTime(new Date(), null, true) + " 00:00");
        _this.scheduleDisabled = false;
        _this.statusDisabled = false;
        _this.form = _this.getOriFormData();
        _this.selections = {
            statusSelector: [
                { value: 'INTENTION', label: '意向' },
                { value: 'PRE_LOCK', label: '预锁' },
                { value: 'SUCCESS', label: '已成交' },
            ],
        };
        return _this;
    }
    Object.defineProperty(EditClueModal.prototype, "rules", {
        get: function () {
            return rules();
        },
        enumerable: false,
        configurable: true
    });
    EditClueModal.prototype.scheduleChange = function (val) {
        // if (!this.firstLoading) this.form.boothId = [];
        var _this = this;
        if (!val || !val.length) {
            this.$nextTick(function () {
                _this.scheduleDisabled = true;
            });
        }
        else {
            this.scheduleDisabled = false;
        }
    };
    /* method */
    EditClueModal.prototype.init = function (id) {
        var _this = this;
        this.firstLoading = true;
        getClueStatusOptions().then(function (res) {
            _this.selections.statusSelector = res;
        });
        getClueDetailInfo({ id: id }).then(function (result) {
            if (result.clueStatus === 'CLOSED') {
                _this.$message.warning('线索已关闭～');
                _this.$emit('loadData');
                _this.beforeClose();
                return;
            }
            _this.storeId = result.shopId;
            _this.form = {
                id: id,
                status: result.clueStatus,
                name: result.name,
                schedule: [result.startAt, result.endAt],
                boothId: [result.shopId, result.boothId],
            };
            _this.statusDisabled = result.clueStatus === 'SUCCESS';
            _this.currentData = {
                shopId: result.shopId,
                shopName: result.shopName,
                boothId: result.boothId,
                boothName: result.boothName,
                saleOrderId: result.saleOrderId,
            };
            _this.showDialog = true;
            // this.$emit('loadData');
            _this.$nextTick(function () {
                _this.firstLoading = false;
            });
        });
    };
    // 获取初始化的表单
    EditClueModal.prototype.getOriFormData = function () {
        return {
            id: '',
            status: 'INTENTION',
            name: '',
            schedule: [],
            boothId: [],
        };
    };
    // 点击提交按钮
    EditClueModal.prototype.submit = function () {
        var _this = this;
        this.$refs.submitForm.validate(function (valid) {
            if (!valid) {
                _this.$message({
                    type: 'error',
                    message: "\u4FE1\u606F\u672A\u586B\u5199\u5B8C\u6574\uFF0C\u8BF7\u68C0\u67E5",
                });
                return false;
            }
            else {
                _this.postClueSubmit();
            }
        });
    };
    // 提交
    EditClueModal.prototype.postClueSubmit = function () {
        var _this = this;
        var params = this.paramsHandle();
        if (this.loading)
            return false;
        this.loading = true;
        putClueDetail(params).then(function (res) {
            _this.$message({
                type: 'success',
                message: "\u64CD\u4F5C\u6210\u529F",
            });
            _this.form = Object.assign(_this.form, _this.getOriFormData());
            _this.$emit('loadData', res);
            _this.beforeClose();
        }, function () {
            _this.loading = false;
        });
    };
    EditClueModal.prototype.paramsHandle = function () {
        var params = deepCopy(this.form);
        var schedule = this.form.schedule;
        params.startAt = schedule[0];
        params.endAt = schedule[1];
        delete params.schedule;
        params.boothId = params.boothId[1];
        return params;
    };
    EditClueModal.prototype.beforeClose = function () {
        this.showDialog = false;
        this.loading = false;
    };
    __decorate([
        Watch('form.schedule')
    ], EditClueModal.prototype, "scheduleChange", null);
    EditClueModal = __decorate([
        Component({
            components: {
                FormModal: FormModal,
                FormInput: FormInput,
                FormDatePicker: FormDatePicker,
                FormRadio: FormRadio,
                FormBoothCascader: FormBoothCascader,
                FormItemTip: FormItemTip,
            },
        })
    ], EditClueModal);
    return EditClueModal;
}(Vue));
export default EditClueModal;
